module.exports = __webpack_public_path__ + "static/media/m_sf_7.aaa457b2.png";